module.exports = "/images/img-2.png?1b8d4af34914afa8d3095bc4129ca3b4";